/**
 * 采购场景下的订单 票据 合同
 */
import moment from 'moment';
import { message } from 'doraemon';
import { isEmpty, uniqBy } from 'lodash';
import { asyncOcr } from 'src/routes/Note/services';
import { v4 as uuidv4 } from 'uuid';
import { getTimeDiff } from 'src/utils/utils';
import { unConnectApplyForm, connectApplyForm } from 'src/routes/Order/services';
import { getBindingDetailFromOrder, getOrderDetail, getUnitOrder, onOcrResultAndAuthenticity, purchaseTradeCheck, batchImportContract, purchaseTradeInit } from '../services';

export default {
  namespace: 'orderInfo',
  state: {
    // 订单集合
    orderList: [],
    // 订单列表带来的订单
    orderListFromOrderList: [],
    // 订单详情
    orderDetail: {},
    // 合同
    contractList: [],
    // 是否是手动添加合同
    isContractManually: false,
    // 发票
    invoiceList: [],
    // 订单集合里的合同
    contractListOfOrder: [],
    // 订单集合里的发票
    invoiceListOfOrder: [],
    cacheInvoiceList: {},
    // 政采云来源的合同
    contractListOfZcy: [],
  },
  effects: {
    /** 政采云订单、合同初始化前的校验 */
    * purchaseTradeCheck({ payload }, { call }) {
      const res = yield call(purchaseTradeCheck, payload);
      return res;
    },
    /** 导入合同 */
    * batchImportContract({ payload }, { call }) {
      const res = yield call(batchImportContract, payload);
      return res;
    },
    /** 初始化政采云订单、合同 */
    * purchaseTradeInit({ payload }, { call }) {
      const res = yield call(purchaseTradeInit, payload);
      return res;
    },
    /**
     * 订单去查合同和发票
     */
    * getBindingDetailFromOrder({ payload }, { call, put, select }) {
      const contractList = yield select(state => state.orderInfo.contractList);
      if (payload.orderList.length > 0) {
        const result = yield call(getOrderDetail, payload);
        result?.contractExpenseFormList?.forEach(ele => {
          ele.indexNo = uuidv4();
          ele.paymentMethod = ele.stagingType;
          ele.orderCodeList = ele.orderCode ? [ele.orderCode] : [];
        });

        yield put({
          type: 'update',
          payload: {
            // 之前的
            // 现在的：如果订单下能查到合同==>直接覆盖
            contractList: result?.contractExpenseFormList?.length > 0 ? result?.contractExpenseFormList : contractList,
            // invoiceList: uniqBy((invoiceList || []).concat(res.formInvoiceInfoList || []), i => `${i?.orderCode}-${i?.platformInvoiceId}-${i?.issueDate}`) || [],
            invoiceList: result?.formInvoiceInfoList,
          },
        });
        return result;
      }
    },

    /**
     * 全链路2期
     * 订单去查合同和发票
     */
    * getInvoiceContractFromOrder({ payload }, { call, put, select }) {
      const contractList = yield select(state => state.orderInfo.contractList);
      const invoiceList = yield select(state => state.orderInfo.invoiceList);
      const orderList = [...payload.orderList];
      if (payload.orderList.length > 0) {
        const result = yield call(getOrderDetail, payload);

        result?.contractExpenseFormList?.forEach(ele => {
          const index = contractList.findIndex(i => i.contractCode === ele.contractCode);
          if (index !== -1 && ele.orderCode) {
            if (!contractList[index].orderCodeList.includes(ele.orderCode)) {
              contractList[index].orderCodeList = [...contractList[index].orderCodeList, ele.orderCode];
            }
          } else {
            contractList.push({
              ...ele,
              paymentMethod: ele.stagingType,
              orderCodeList: ele.orderCode ? [ele.orderCode] : [],
              contractExpenseAmount: ele.stagingType === 1 ? ele.contractRemainingAmount : undefined,
              indexNo: uuidv4()
            });
            if (ele.stagingType === 1) {
              // const ind = orderList.findIndex(i => i.orderCode === ele.orderCode);
              orderList[0].orderExpenseAmount = ele.contractRemainingAmount;
            }
          }
        });
        yield put({
          type: 'update',
          payload: {
            contractList,
            orderList: orderList,
            invoiceList: uniqBy((invoiceList || []).concat(result?.invoiceList || []), i => `${i?.orderCode}-${i?.platformInvoiceId}-${i?.issueDate}`) || [],
          },
        });
        return result;
      }
    },

    * getInvoiceByOrder({ payload }, { call, put, select }) {
      const orderList = yield select(state => state.orderInfo.orderList);
      if (orderList.length === 0) {
        return []
      }
      const { orderCode, operatorId } = orderList[0];
      if(!orderCode){
        return [];
      }
      const result = yield call(getOrderDetail, { orderCode, operatorId });
      return result?.formInvoiceInfoList || [];
    },
    /**
     * 订单去查详情
     */
    * getOrderDetail({ payload }, { call, put }) {
      const orderDetail = yield call(getOrderDetail, payload);
      yield put({
        type: 'update',
        payload: {
          orderDetail,
          contractListOfOrder: orderDetail?.contractExpenseFormList || [],
          invoiceListOfOrder: orderDetail?.formInvoiceInfoList || [],
        },
      });
    },
    /**
     * 订单去清除详情详情 */
    * clearOrderDetail({}, { put }) {
      yield put({
        type: 'update',
        payload: {
          orderDetail: {},
          contractListOfOrder: [],
          invoiceListOfOrder: [],
        },
      });
    },
    * setOrderDetail({ payload }, { call, put }) {
      const { contractList = [] } = payload;
      yield put({
        type: 'update',
        payload: {
          orderDetail: payload,
          contractList: !isEmpty(contractList) ? contractList : [],
        },
      });
    },
    /**
    * 重新使用订单去查合同和发票
    */
    * getBindingDetailFromAllOrder({ payload }, { call, put, select }) {
      const contractList = yield select(state => state.orderInfo.contractList);
      const invoiceList = yield select(state => state.orderInfo.invoiceList);
      const orderList = yield select(state => state.orderInfo.orderList);
      if (orderList.length > 0) {

        const res = yield call(getBindingDetailFromOrder, { orderList });
        yield put({
          type: 'update',
          payload: {
            contractList: uniqBy(contractList.concat(res?.result?.contractList || []), i => i?.orderCode + i?.indexNo) || [],
            invoiceList: uniqBy((invoiceList).concat(res?.result?.invoiceList || []), i => i?.zcyId) || [],
          },
        });
        return uniqBy((invoiceList).concat(res?.result?.invoiceList || []), i => i?.zcyId) || [];
      }
      return [];
    },

    * invoiceOcr({ payload }, { call, put }) {
      const taskCode = yield call(asyncOcr, payload);
      // 缓存已经ocr过的发票
      const temp = {};
      payload?.forEach(item => {
        Reflect.set(temp, item.orderCode, item);
      });
      yield put({
        type: 'update',
        payload: {
          cacheInvoiceList: temp
        },
      });

      if (!taskCode) return Promise.reject(new Error());
      let dateTime = 0;
      const result = yield new Promise((resolve) => {
        const queryOcrResult = (code, count) => {
          const cnt = count - 1;
          // eslint-disable-next-line no-undef
          setTimeout(() => {
            onOcrResultAndAuthenticity({ taskCode: code, checkTenantConfig: true }).then((res) => {
              if (res) {
                resolve(res);
                return;
              }
              const newDate = moment().valueOf();
              if (!cnt || getTimeDiff(newDate, dateTime) > 30) {
                // 超出最大次数
                message.error('发票上传超时');
                return;
              }
              queryOcrResult(taskCode, cnt);
            }).catch(() => {
            });
          }, 1000);
        };
        queryOcrResult(taskCode, 30);
        dateTime = (moment().valueOf());
      });

      return result;
    },
    * undoApplyForm({ payload }, { call, put }) {
      const res = yield call(unConnectApplyForm, payload);
      return res;
    },
    * connectApplyForm({ payload }, { call, put }) {
      const res = yield call(connectApplyForm, payload);
      return res;
    },
    * getUnitOrder({ payload }, { call, put, select }) {
      // 申请单关联的订单获取
      const res = yield call(getUnitOrder, payload);
      return res;
    },
    * updateData({ payload }, { call, put }) {
      yield put({
        type: 'update',
        payload,
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    emptyLists(state) {
      return {
        ...state,
        contractList: [],
        orderList: [],
        orderListFromOrderList: [],
        invoiceList: [],
        // 发票
        // 订单集合里的合同
        contractListOfOrder: [],
        // 订单集合里的发票
        invoiceListOfOrder: [],
      };
    },
    deleteFromOrder(state, { payload }) {
      // payload.setNoteList(i => i?.orderCode !== payload.orderCode)
      return {
        ...state,
        contractList: state.contractList.filter(i => i?.orderCode !== payload.orderCode),
        invoiceList: state.invoiceList.filter(i => i?.orderCode !== payload.orderCode),
      };
    },
    batchDeleteFromOrder(state, { payload }) {
      let tempContractList = state.contractList.concat();
      let tempInvoiceList = state.invoiceList.concat();
      const orderCodeList = payload.orderList?.map(i => i.orderCode);
      tempContractList = tempContractList.filter(i => {
        // 没有orderCode手动添加的不删除
        return !i.orderCode || !orderCodeList?.includes(i.orderCode);
      });
      tempInvoiceList = tempInvoiceList.filter(i => {
        // 没有orderCode手动添加的不删除
        return !i.orderCode || !orderCodeList?.includes(i.orderCode);
      });

      return {
        ...state,
        contractList: tempContractList,
        invoiceList: tempInvoiceList,
      };
    },
    saveDetail(state, { payload }) {
      return {
        ...state,
        orderList: payload?.orderExpenseFormList || [],
        contractList: payload?.contractExpenseFormList || [],
        invoiceList: payload?.formInvoiceInfoList || [],
      };
    },
  },
};
